import { render, staticRenderFns } from "./AamsBaseSealReasonCategory.vue?vue&type=template&id=a31e7070&scoped=true&"
import script from "./AamsBaseSealReasonCategory.vue?vue&type=script&lang=js&"
export * from "./AamsBaseSealReasonCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31e7070",
  null
  
)

export default component.exports